import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'sl23',
  templateUrl: './sl23.component.html',
  styleUrls: ['./sl23.component.scss']
})
export class Sl23Component {
  @Input() package: any;
  @Output() link = new EventEmitter<string>();
  constructor(
    private router: Router
  ) {}
  

  protected emitLink(link: string):void{
    this.link.emit(link);
  }
}
